import { useMediaQuery, useTheme } from '@material-ui/core'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { useSectionId } from '@v4/components/common/SectionItem'
import useStyles from './Cta16_17.styled'

// eslint-disable-next-line camelcase
export const useCta16_17 = props => {
	const { metaData } = props
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	const sectionId = useSectionId()
	const items = PageBuilderSelector.useRepeatableGroupKeys({
		sectionId,
		group: 'items',
	})
	const classes = useStyles(props)

	const { handleFocus: handleTitleClick } = useFieldFocus({ metaData: metaData.title })
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.image })
	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonAction })
	const { handleFocus: handleAdditionalTextClick } = useFieldFocus({ metaData: metaData.additionalText })

	const { editable: titleEditable, handleChange: handleTitleChange } = useEditorMeta({
		metaData: metaData.title,
		key: 'title',
	})
	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaData.buttonText,
		key: 'buttonText',
	})

	const { editable: additionalTextEditable, handleChange: handleAdditionalTextChange } = useEditorMeta({
		metaData: metaData.additionalText,
		key: 'additionalText',
	})

	const image = isMobile && metaData.mobileImage?.image ? metaData.mobileImage : metaData.image

	const isBackground = metaData.mobileImagePosition?.isBackgroundImage

	const isCenter = metaData.mobileImagePosition?.isCenterImage

	const withTopContent = isMobile ? isCenter || !metaData.mobileImagePosition?.metaValue : true

	return [
		{
			classes,
			items,
			isMobile,
			image,
			contentWidth: metaData.contentWidth?.metaValue,
			direction: isMobile ? metaData.mobileImagePosition?.contentDirection() : null,
			withBgImage: isMobile && isBackground && !!image?.image,
			withImageCenter: !!image?.image && withTopContent,
			withMobileImage: isMobile && !isCenter && !isBackground && !!image?.image,

			withTopContent,

			title: metaData.title?.metaValue,
			titleConfig: metaData.title?.config,
			titleKey: metaData.title?.tierKey,
			titleEditable,

			text: metaData.text?.metaValue,
			textConfig: metaData.text?.config,
			textKey: metaData.text?.tierKey,
			textEditable,

			buttonText: metaData.buttonText?.metaValue,
			buttonTextConfig: metaData.buttonText?.config,
			buttonLink: metaData.buttonLink?.metaValue,
			buttonAction: metaData.buttonAction?.metaValue,
			buttonTextKey: metaData.buttonText?.tierKey,
			buttonTextEditable,

			additionalText: metaData.additionalText?.metaValue,
			additionalTextConfig: metaData.additionalText?.config,
			additionalTextKey: metaData.additionalText?.tierKey,
			additionalTextEditable,
		},
		{
			handleImageClick,

			handleTextClick,
			handleTextChange,

			handleButtonClick,
			handleButtonTextChange,

			handleTitleClick,
			handleTitleChange,

			handleAdditionalTextClick,
			handleAdditionalTextChange,
		},
	]
}
